import { A } from "@solidjs/router";
import { createResource, For, Show } from "solid-js";

import { fetchSectorsSummary, type SectorSummary } from "../api";

function fmtMoneyB(b: number): string {
  if (b >= 1000) return `$${(b / 1000).toFixed(2)}T`;
  return `$${b.toFixed(0)}B`;
}

export default function Sectors() {
  const [sectorsRes] = createResource(fetchSectorsSummary);

  return (
    <section class="sectors-page">
      <div class="sectors-head">
        <h2>Sectors</h2>
        <Show when={sectorsRes()}>
          {(items) => (
            <span class="sub">
              GICS · {items().length} sectors · {items().reduce((n, s) => n + s.firm_count, 0)} firms · sorted by market cap
            </span>
          )}
        </Show>
      </div>

      <Show
        when={!sectorsRes.loading && (sectorsRes() ?? []).length > 0}
        fallback={<div class="loading">loading sectors...</div>}
      >
        <div class="sectors-grid">
          <For each={sectorsRes() ?? []}>
            {(s: SectorSummary) => (
              <A
                class="sector-card"
                href={`/firms?sector=${encodeURIComponent(s.name)}`}
                title={`See all ${s.firm_count} firms in ${s.name}`}
              >
                <div class="sc-head">
                  <span class="sc-name">{s.name}</span>
                  <span class="sc-count">{fmtMoneyB(s.combined_market_cap_b_usd)}</span>
                </div>
                <div class="sc-kv">
                  <span class="k">Firms</span>
                  <span class="v">{s.firm_count}</span>
                </div>
                <div class="sc-kv">
                  <span class="k">Revenue</span>
                  <span class="v">{fmtMoneyB(s.combined_revenue_b_usd)}</span>
                </div>
                <div class="sc-kv">
                  <span class="k">Modeled</span>
                  <span class="v">
                    {s.modeled} <span class="dim">/ {s.firm_count}</span>
                  </span>
                </div>
                <Show when={s.top_firms.length > 0}>
                  <div class="sc-top">
                    <span class="k">Top</span>
                    <span class="v">
                      {s.top_firms
                        .map((t) => t.ticker ?? t.slug.toUpperCase())
                        .join(" · ")}
                    </span>
                  </div>
                </Show>
              </A>
            )}
          </For>
        </div>
      </Show>
    </section>
  );
}
